// tippi/src/utils/carrierOrderTimeline.js
import { toDate } from './orderCardFormat';

// Hendelser for en egen ordre, utledet av tidsstemplene på ordren. nameOf(uid) gir navnet til en sjåfør.
export function buildCarrierOrderTimeline(order, nameOf = () => 'Sjåføren') {
  const events = [];
  const add = (key, label, value, detail = '') => {
    const at = toDate(value);
    if (at) events.push({ key, label, at, detail });
  };
  add('created', 'Opprettet', order.createdAt);
  (order.declineHistory ?? []).forEach((d, i) => add(`declined-${i}`, `Avslått av ${nameOf(d.uid)}`, d.at, d.reason));
  if (order.status === 'offered') add('offered', `Tilbudt ${nameOf(order.offeredToUid)}`, order.offeredAt);
  add('matched', order.driverUid ? `Godtatt av ${nameOf(order.driverUid)}` : 'Godtatt', order.matchedAt);
  add('picked', 'Hentet', order.pickupRegisteredAt, order.pickupActualTons != null ? `${String(order.pickupActualTons).replace('.', ',')} tonn` : '');
  add('delivered', 'Levert', order.deliveredAt);
  add('cancelled', 'Kansellert', order.cancelledAt, order.cancelReason ?? '');
  return events.sort((a, b) => a.at - b.at);
}
